export default __webpack_public_path__ + "static/media/arrow_right.da1ea8db.svg";